import PlusCircle from '../src/PlusCircle/index';
export default PlusCircle;
